export const camelToSnakeCase = (str: string): string => str.replace(/[A-Z]/g, (letter) => `_${letter}`);
